var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRotateCounterClockwise = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 46
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Rotate Counter Clockwise"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "current",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 46,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 45,
  height: 45,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M24 28.91a5.993 5.993 0 0 0 0-11.82V21l-4.55-4.45L24 12v3.07a7.992 7.992 0 0 1 0 15.86Zm-5.9.41 1.44-1.45A5.914 5.914 0 0 0 22 28.9v2.03a7.926 7.926 0 0 1-3.9-1.61ZM15.07 24h2.02a6 6 0 0 0 1.01 2.47l-1.41 1.42A7.908 7.908 0 0 1 15.07 24Zm0-2a7.924 7.924 0 0 1 1.63-3.89l1.41 1.42A5.935 5.935 0 0 0 17.09 22Z",
  fill: "#376996"
}))));
export default SvgRotateCounterClockwise;